module.exports = __webpack_public_path__ + "static/media/HCMM235.c347b6fa.jpg";